/* eslint-disable */

import { useState } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import "react-phone-input-2/lib/style.css";
import AddCustomerForm from "./form";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useEffect } from "react";
import useCustomerHook from "./useCustomerHook";

const AddCustomer = () => {
  const [menu, setMenu] = useState();
  const { uuid } = useParams();
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const { FetchSingleCustomer } = useCustomerHook();
  const { customer, customerLoading } = FetchSingleCustomer(uuid);
  function unformatCustomerData(input) {
    const customer = input || {};
    console.log("Unformatted customer data:", customer);
    const billing = customer.billing_address || {};
    const shipping = customer.shipping_address || {};
    const bank = customer.bank_detail || {};
const leadStage = [
  { value: "new", label: "New" },
  { value: "technical", label: "Technical" },
  { value: "false_inquiry", label: "False inquiry" },
  { value: "follow_up", label: "Follow up" },
];
    return {
      currency_type: input.currency_type, // default or set if available elsewhere
      phone: input.user.mobile_number ? input.user.mobile_number : "",
      full_name: input.user.full_name || "",
      email: input.user.email || "",
      notes: customer.notes || "",
      company_name: customer.company_name || "",
      // Billing address
      billing_name: billing.name || "",
      billing_address1: billing.address_line1 || "",
      billing_address2: billing.address_line2 || "",
      billing_country: billing.country || "",
      billing_state: billing.state || "",
      billing_city: billing.city || "",
      billing_pincode: billing.pincode || "",

      // Shipping address
      shipping_name: shipping.name || "",
      shipping_address1: shipping.address_line1 || "",
      shipping_address2: shipping.address_line2 || "",
      shipping_country: shipping.country || "",
      shipping_state: shipping.state || "",
      shipping_city: shipping.city || "",
      shipping_pincode: shipping.pincode || "",
      lead_source: customer.lead_source || "",
      lead_stage: leadStage.find((stage) => stage.value === customer?.lead_stage),

      // Bank details (flatten with `bank_` prefix)
      bank_name: bank.bank_name || "",
      bank_branch: bank.branch || "",
      bank_account_holder_name: bank.account_holder_name || "",
      bank_account_number: bank.account_number || "",
      bank_ifsc: bank.ifsc || "",
      swift_code: bank.swift_code || ""
    };
  }

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="card mb-0">
              <div className="card-body">
                {/* Page Header */}
                <div className="page-header">
                  <div className="content-page-header">
                    <h5>Add Customers</h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    {!customerLoading && uuid && (
                      <AddCustomerForm isEdit={Boolean(uuid)} uuid={uuid} data={unformatCustomerData(customer)} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddCustomer;
